export const getCandidateType = (pathname: string) => {
  if (pathname.includes('archived')) return 'archived';
  if (pathname.includes('qualified')) return 'qualified';
  if (pathname.includes('hired')) return 'hired';
  return 'new';
};
